<script lang="ts">
	import { fade, fly } from 'svelte/transition';

	interface Props {
		key: string;
		duration?: number;
		children?: import('svelte').Snippet;
	}

	let { key, duration = 300, children }: Props = $props();
</script>

{#key key}
	<div in:fly={{ y: -10, duration: duration, delay: 350 }} out:fly={{ y: 10, duration: duration }}>
		{@render children?.()}
	</div>
{/key}
